import { render, staticRenderFns } from "./AmlApprovedModal.vue?vue&type=template&id=a31708b2&scoped=true"
import script from "./AmlApprovedModal.vue?vue&type=script&lang=js"
export * from "./AmlApprovedModal.vue?vue&type=script&lang=js"
import style0 from "./AmlApprovedModal.vue?vue&type=style&index=0&id=a31708b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31708b2",
  null
  
)

export default component.exports